import React, { Component } from 'react';
import axios from 'axios'
import { Header } from 'semantic-ui-react'
import { Form, Segment, Button, Divider, Grid, List } from 'semantic-ui-react'
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { Link } from 'react-router-dom';
import { firebaseAuth, pythonApiIp, toCurrency, logComponentLoad, logDashboardAction } from '../../../../config/constants'
import { checkAdminEmail } from '../algoliaDashboard/AlgoliaMiscUtils';
import * as UiConsts from '../../../../config/UiConstants';
import LargeProjectsNav from './LargeProjectsNav'
import EnterProjectCosts from './EnterProjectCosts';
import EnterProjectInHouseCosts from './EnterProjectInHouseCosts'
import { SingleDatePicker } from 'react-dates';
import DocumentUploader from './DocumentUploader'
import ViewLargeProjectDocs from './ViewLargeProjectDocs'

import createBrowserHistory from 'history/createBrowserHistory';
import AddDate from './AddDates';
import AddExpectedPaymentDate from './AddExpectedPaymentDate'
import AddVatToProject from './AddVatToProject';
import AddPaymentToProject from './AddPaymentToProject';
import ArchiveProject from './ArchiveProject';
import AddMoneySentOnProject from './AddMoneySentOnProject';
import ViewReceiptOnPoject from './ViewReceiptOnPoject'
import ViewLargeProjectDocuments from './ViewLargeProjectDocuments'
import TinNumberAddCustomer from './TinNumberAddCustomer';



const history = createBrowserHistory({ forceRefresh: true });

class MobileEnterProjectCosts extends Component {
    constructor(props) {
        super(props);
        this.state = {
            salesPeople: '',
            salesPeopleChoices: [],
            customerChoices: [],
            customers: '',
            loading: false,
            totalPayment: '',
            projectName: '',
            salesperson: '',
            customerId: '',
            salesPersonId: '',
            totalPayment: '',
            projectCosts: '',
            project: '',
            totalPayment: 0,
            enterCostsToggle: true,
            enterInHouseCostsToggle: false,
            order_num: 0,
            orders: [],
            dateNum: ''
        }
    }

    showEnterCosts = () => {
        let show = this.state.enterCostsToggle;

        if (show == true) {
            this.setState({
                enterCostsToggle: false
            })
        } else if (show == false) {
            this.setState({
                enterCostsToggle: true
            })
        }
    }

    showEnterInHouseCosts = () => {
        console.log("inhpc1 ++++++ showEnterInHouseCosts +++++")
        let show = this.state.enterInHouseCostsToggle;

        if (show == true) {
            console.log("inhpc12 show == true");
            this.setState({
                enterInHouseCostsToggle: false
            })
        } else if (show == false) {
            console.log("inhpc13 show == false");
            this.setState({
                enterInHouseCostsToggle: true
            })
        }
    }

    componentDidMount() {
        console.log("addx2 ++++++++++ searchNow componentDidMount");


        this.removeListener = firebaseAuth().onAuthStateChanged((user) => {
            console.log("addx24 +++++++++:firebaseAuth().onAuthStateChanged");

            if (user) {
                console.log("addx241 user is:" + user.email);
                // let isAnonymous = user.isAnonymous;
                // let uid = user.uid;

                if (user.email) {
                    console.log("addx290 user.email  is:" + user.email);
                    this.setState({
                        user: user
                    })

                    //CHECK ALGOLIA FOR USER
                    checkAdminEmail(user.email, this.setAdminResult)
                    // this.getApiDetails();
                    //this.getProjectCosts();
                }

            } else {
                console.log("rlx121 user NOT found");
                this.setState({
                    authed: false,
                    // loading: false,
                    user: user,
                    uid: user.uid
                })

            }
        })

    }

    setAdminResult = (returnObject) => {
        // console.log("++++++ addx294 setAdminResult");
        // console.log("addx2941 returnObject:" + JSON.stringify(returnObject, null, 3));

        logComponentLoad(returnObject, "ViewSingleLargeProject");

        if (returnObject.algoliaUser.perms && returnObject.algoliaUser.perms.includes("sales")) {
            this.getProjectCosts();
        }


        this.setState({
            algoliaUser: returnObject.algoliaUser,
            //isAdmin: returnObject.isAdmin,
        })
    }

    handleTextInputChange = (e) => {
        // console.log("hx1 >>>>: handleTextInputChange clicked");
        // console.log("hx33 e.target.type:" + e.target.type);
        console.log("hx32 e.target.name:" + e.target.name);
        console.log("hx34 e.target.value:" + e.target.value);
        let newState = {};
        newState[e.target.name] = e.target.value;

        let name = e.target.name;
        let value = e.target.value;

        this.setState(newState);

    }

    handleDropDownChanges = (value) => {
        console.log("lst1 handleDropDownChanges");
        console.log('lst12 You\'ve sss:', value);
        console.log("lst13 category alone:" + value.category);
        console.log('lst14 You\'ve selected:', value.value + " " + value.category);
        console.log("lst15 -  this.props.itemSelected:" + this.state.itemSelected);
        console.log("lst16 - array index:" + this.props.arrayIndex);

        let newState = {};
        newState[value.category] = value.value;
        console.log("newState 1:" + JSON.stringify(newState, null, 3));

        //this.setState(newState);
        this.setState(newState);
    }



    getProjectCosts = () => {
        console.log("++++++++:getProjectCosts");

        this.setState({ loading: true })

        axios.post(pythonApiIp + 'getProjectCosts', {
            apiKey: "asdfsdf&ddd",
            projectId: this.props.match.params.projectId
        })
            .then((response) => {
                this.setState({ loading: false })
                console.log(response.data);

                if (response.data.result) {
                    // console.log("true.. adding customer");
                    console.log("pltx2 projectCosts:" + JSON.stringify(response.data, null, 3))
                    this.setState({
                        project: response.data.project,
                        salesperson: response.data.project.salesperson.name,
                        projectCosts: response.data.projectCosts,
                        orders: response.data.orders,
                    })

                    //logDashboardAction(logAction, adminEmail, order_num, componentName) {
                    logDashboardAction(this.state.user.email + " loaded #" + response.data.project.idlargeprojects + " -" + response.data.project.name, this.state.user.email, null, "ViewSingleLargeProject");

                    //GET TOTAL COSTS
                    this.getProjectTotalCost(response.data.projectCosts)
                } else {
                    console.log("FAILED");
                    alert(response.data.message);
                    history.push("/dashboard/largeProjectsHome");
                }
            })
            .catch((error) => {
                console.log(error);
                this.setState({
                    loading: false
                })
            });

    }

    getProjectTotalCost = (projectCosts) => {
        // console.log("gtx1 get total project cost")
        // console.log("gtx1 project costs:" + projectCosts.length)

        let total = 0;
        projectCosts.forEach(element => {
            // console.log("gtx10 get element cost:" + (element.qty * element.cost))
            total += (element.qty * element.cost)
            // console.log("gtx12 new total:" + total)
        });

        this.setState({
            totalCost: total
        })
    }

    approveCosts = () => {
        console.log("appx1 ++++++++:approveCosts");
        console.log("appx12:" + this.props.match.params.projectId)
        console.log("appx13:" + this.state.user.email)

        if (this.state.projectId == '') {
            alert("No projectId Person")
        } else if (this.state.user.email == '') {
            alert("No Entered By Provided")
        } else {
            console.log("sending data..");

            this.setState({ loading: true });

            axios.post(pythonApiIp + 'approveCosts', {
                apiKey: "asdf@daddd",
                projectId: this.props.match.params.projectId,
                enteredBy: this.state.user.email,
            })
                .then((response) => {

                    console.log("appx14 result:" + JSON.stringify(response.data, null, 3));

                    if (response.data.result) {
                        console.log("true.. approving costs");

                        alert(response.data.message);
                        history.push("/dashboard/viewLargeProject/" + this.props.match.params.projectId);
                    } else {
                        console.log("FAILED");
                        this.setState({
                            loading: false
                        })
                        alert(response.data.message);
                    }
                })
                .catch((error) => {
                    console.log(error);
                    this.setState({
                        loading: false
                    })
                });
        }
    }

    salesPersonApproval = () => {
        console.log("appx1 ++++++++:salesPersonApproval");
        console.log("appx12:" + this.props.match.params.projectId)
        console.log("appx13:" + this.state.user.email)

        if (this.state.projectId == '') {
            alert("No projectId Person")
        } else if (this.state.user.email == '') {
            alert("No Entered By Provided")
        } else {
            console.log("sending data..");

            this.setState({ loading: true });

            axios.post(pythonApiIp + 'salesPersonApproval', {
                apiKey: "asdfasdf&adsf",
                projectId: this.props.match.params.projectId,
                enteredBy: this.state.user.email,
            })
                .then((response) => {

                    console.log("appx14 result:" + JSON.stringify(response.data, null, 3));

                    if (response.data.result) {
                        console.log("true.. approving costs");

                        alert(response.data.message);
                        history.push("/dashboard/viewLargeProject/" + this.props.match.params.projectId);
                    } else {
                        console.log("FAILED");
                        this.setState({
                            loading: false
                        })
                        alert(response.data.message);
                    }
                })
                .catch((error) => {
                    console.log(error);
                    this.setState({
                        loading: false
                    })
                });
        }
    }


    dateSelectOnChange = (date) => {
        console.log("++++++++:dateSelectOnChange");
        console.log("date:" + date);
        console.log("date.getValue():" + date.valueOf());
        this.setState({
            date: date,
            dateNum: date.valueOf(),
            dateString: date.format('dddd MMMM Do')

        })
    }


    render() {

        const projName = <Header as='h2'>
            {this.state.project.name}
            <Header.Subheader>
                Project Name
        </Header.Subheader>
        </Header>

        // const totalpayment = <Header as='h2' color='blue'>
        //     {toCurrency(this.state.project.totalpayment)}
        //     <Header.Subheader>
        //         Total Amount Paid
        //     </Header.Subheader>
        // </Header>

        const totalpayment = <List.Item>
            <List.Header>{toCurrency(this.state.project.totalpayment)}</List.Header>
            <List.Description>
                Total Amount Paid
</List.Description>
        </List.Item>

        // const projCost = <Header as='h2' color='red'>
        //     {toCurrency(this.state.totalCost)}
        //     <Header.Subheader>
        //         Total Cost
        // </Header.Subheader>
        // </Header>

        const projCost = <List.Item>
            <List.Header>{toCurrency(this.state.totalCost)}</List.Header>
            <List.Description>
                Total Cost
</List.Description>
        </List.Item>

        //         const profit = <Header as='h2' color='green'>
        //             {toCurrency(this.state.project.totalpayment - this.state.totalCost)}
        //             <Header.Subheader>
        //                 Profit
        // </Header.Subheader>
        //         </Header>

        const profit = <List.Item>
            <List.Header>{toCurrency(this.state.project.totalpayment - this.state.totalCost)}</List.Header>
            <List.Description>
                Profit
</List.Description>
        </List.Item>


        //         const salesPerson = <Header as='h3' color='teal'>
        //             {this.state.salesperson}
        //             <Header.Subheader>
        //                 Sales Person
        // </Header.Subheader>
        //         </Header>

        const salesPerson = <List.Item>
            <List.Header> {this.state.salesperson}</List.Header>
            <List.Description>
                Sales Person
</List.Description>
        </List.Item>

        //         const payStatus = <Header as='h3' color='red'>
        //             {this.state.project.paymentstatus} - {this.state.project.datepaid}
        //             <Header.Subheader>
        //                 PAYMENT STATUS
        // </Header.Subheader>
        //         </Header>

        const payStatus = <List.Item>
            <List.Header> {this.state.project.paymentstatus} - {this.state.project.datepaid}</List.Header>
            <List.Description>
                PAYMENT STATUS
</List.Description>
        </List.Item>

        //         const costsApproved = <Header as='h2' color='violet'>
        //             {this.state.project.costsapprovedyesno}
        //             <Header.Subheader>
        //                 Cost Approved
        // </Header.Subheader>
        //         </Header>

        //         const salesPersonApproved = <Header as='h2' color='brown'>
        //             {this.state.project.salespersonapproved}
        //             <Header.Subheader>
        //                 Sales Person Approved
        // </Header.Subheader>
        //         </Header>

//         const orderdeliveredUi = this.state.project.orderdelivered
//             ? <Header as='h3' color='brown'>
//                 {this.state.project.orderdelivered} - {this.state.project.datedelivered}
//                 <Header.Subheader>
//                     Order Delivered
// </Header.Subheader>
//             </Header>
//             : <Header as='h3' color='brown'>
//                 NOT Delivered
//             <Header.Subheader>
//                     Order Delivered
// </Header.Subheader>
//             </Header>

        const orderdeliveredUi = this.state.project.orderdelivered
            ? <List.Item>
                <List.Header> {this.state.project.orderdelivered} - {this.state.project.datedelivered}</List.Header>
                <List.Description>
                    Order Delivered
</List.Description>
            </List.Item>
            : <List.Item>
                <List.Header> NOT Delivered</List.Header>
                <List.Description>
                    Order Delivered
</List.Description>
            </List.Item>

        //  ADD TIN NUMBER -----------
        const showTinNumberDetails = this.state.project && this.state.project.largeprojectcustomer.tin_number_1
            ? <Header as='h3' color='red'>
                TIN #: {this.state.project.largeprojectcustomer.tin_number_1}
                <Header.Subheader>
                    {this.state.project.largeprojectcustomer.customername}
                </Header.Subheader>

            </Header>
            : <Header as='h3' color='brown'>
                NO TIN
<Header.Subheader>
                    no
</Header.Subheader>
            </Header>

        const showOrders = this.state.orders.map((order) =>

            <Header as='h5'>{order.order_num} - <Link to={'/dashboard/SingleOrderViewAlgolia/' + order.order_num} target="_blank">VIEW</Link></Header>
        )

        // DATE ORDER WAS PAID
        const enterTotalPayment =
            <div>
                <Divider horizontal>{'ENTER TOTAL PAYMENT'}</Divider>

                <Form size='large' onSubmit={this.sendTotalPayment}>
                    <Segment stacked>

                        <h3>Update Order Amount (Amount Customer Is Gonna Pay) </h3>
                        <label>{toCurrency(this.state.totalPayment)}</label>
                        <Form.Input
                            fluid
                            icon='dollar sign'
                            iconPosition='left'
                            placeholder='Total Order Amount'
                            type='number'
                            name="totalPayment"
                            value={this.state.totalPayment}
                            onChange={this.handleTextInputChange}
                        />

                        <Button>SEND TOTAL AMOUNT</Button>
                    </Segment>
                </Form>
            </div>

        const datePaidButton = this.state.dateNum != ''
            ? <Button>SET PAYMENT DATE</Button>
            : ''

        const enterPaymentDate =
            <div>
                <Divider horizontal>{'FULL PAYMENT DATE'}</Divider>

                <Form size='large' onSubmit={this.markProjectPaid}>
                    <Segment stacked>
                        <h3>Select Date Order Was Fully Paid </h3>

                        <SingleDatePicker
                            date={this.state.date} // momentPropTypes.momentObj or null
                            //onDateChange={date => this.setState({ date })} // PropTypes.func.isRequired
                            onDateChange={date => this.dateSelectOnChange(date)} // PropTypes.func.isRequired
                            focused={this.state.focused} // PropTypes.bool
                            isOutsideRange={() => false}
                            onFocusChange={({ focused }) => this.setState({ focused })} // PropTypes.func.isRequired
                        />
                        <h2>{this.state.dateString}</h2>
                        {datePaidButton}
                    </Segment>
                </Form>
            </div>

        const enterCostsUI = this.state.user && this.state.user.email && this.state.enterCostsToggle
            ? <EnterProjectCosts projectId={this.props.match.params.projectId} projectCosts={this.state.projectCosts} user={this.state.user} mobile={true} />
            : ''

        const enterInHouseCostsUI = this.state.user && this.state.user.email && this.state.enterInHouseCostsToggle
            ? <EnterProjectInHouseCosts projectId={this.props.match.params.projectId} showCosts={this.state.enterInHouseCostsToggle} user={this.state.user} />
            : ''

        // const addExpectedPaymentDate = this.state.user
        //     ? <AddExpectedPaymentDate
        //         projectId={this.props.match.params.projectId}
        //         user={this.state.user} />
        //     : ''


        return (
            this.state.loading ? <UiConsts.LoadingComponent /> : <div>

                {/* <LargeProjectsNav /> */}
                {/* ============ PROJECT HEADERS SECTION ================= */}

                <Grid
                    textAlign='center'
                    style={{ height: '100%' }}
                    verticalAlign='middle'
                >
                    <Grid.Column style={{ maxWidth: 450 }}>
                        {projName}

                        <List>

                            {totalpayment}

                            {projCost}

                            {/* TOTAL PAYMENT HEADER */}
                            {totalpayment}

                            {/* TOTAL COST HEADER */}
                            {projCost}

                            {/* TOTAL PROFIT HEADER */}
                            {profit}

                            {/* SALESPERSON */}
                            {salesPerson}

                            {/* IF ORDER DELIVERED */}
                            {orderdeliveredUi}

                            {/* PAYMENT STATUS */}
                            {payStatus}
                        </List>

                        {/* ============ APPROVE COSTS BUTTONS ================= */}
           

                        {/* --- PROJECT COSTS ---- */}
                        {/* <Button fluid onClick={this.showEnterCosts}> Show PROJECT COSTS</Button> */}
                        {enterCostsUI}

                        {/* --- PROJECT IN HOUSE COSTS ---- */}
                        <Button fluid color='violet' onClick={this.showEnterInHouseCosts}> ENTER IN HOUSE TAILOR COSTS</Button>
                        {enterInHouseCostsUI}

                        {/* ============ ADD PROJECT THINGS ================= */}

                        {/* ENTER TOTAL PAYMENT */}
                        {enterTotalPayment}

                        {/* ============ END ADD PROJECT THINGS ================= */}

                    </Grid.Column>
                </Grid>



            </div>
        );
    }
}

export default MobileEnterProjectCosts;


// WEBPACK FOOTER //
// ./src/components/dashBoard/newDashboard/LargeProjects/MobileEnterProjectCosts.js